import * as React from 'react';
import { Alert } from '@grandvisionhq/iris-ui';
import { useIntl } from '@grandvisionhq/state';

const LabelledAlert = ({ variant ='info' , labelKey  })=>{
    const { getLabel  } = useIntl();
    return /*#__PURE__*/ React.createElement(Alert, {
        variant: variant,
        className: "alert-m-default"
    }, getLabel(labelKey));
};

export { LabelledAlert };
//# sourceMappingURL=LabelledAlert.js.map
